/**
 * list route-id > component
 * - key id will be the one of that route - no concat with parent etc
 * - value can be direct cpn or dyna import promise
 */
const pages: {
  [routeId: string]: AsyncImportVue
} = {
  // required
  home: () => import(/* webpackChunkName: "page-home" */ 'pages/Home/index.vue'),
  fourofour: () => import(/* webpackChunkName: "pages-404" */ 'pages/FourOFour.vue'),

  // custom pages
  bio: () => import(/* webpackChunkName: "page-biography" */ 'pages/Biography/index.vue'),
  collection: () => import(/* webpackChunkName: "page-fund" */ 'pages/Fund/index.vue'),
  credit: () => import(/* webpackChunkName: "page-credit" */ 'pages/Credit/index.vue'),
  thematique: () => import(/* webpackChunkName: "page-thematique" */ 'pages/Thematique/index.vue'),
  object: () => import(/* webpackChunkName: "page-thematique" */ 'pages/Thematique/single.vue'),

  termsofuse: () => import(/* webpackChunkName: "pages-termsofuse" */ 'pages/Legal/index.vue'),
  privacyPolicy: () => import(/* webpackChunkName: "pages-privacy_policy" */ 'pages/Legal/index.vue'),

}


export default pages
export const Page404 = pages.fourofour
